import React, {Component} from 'react';
import {useParams} from 'react-router-dom';
import Intestazione from './components_novel/intestazione';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';
import creativeArticles, {getArticlePath} from './data/creativeArticles';
import pillarPages, {getPillarPageBySlug} from './data/pillarPages';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';

const intestazioneBackgroundStyle = {
  backgroundImage: `url(${intestazioneBackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  height: '300px',
};

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class PillarPage extends Component {
  state = {
    aNavbarLinks: [
      {id: 0, linkHref: '/', linkNome: 'ROMANZO'},
      {id: 1, linkHref: '/cos-e-verso-hemelslinn/', linkNome: 'COS’È'},
      {id: 2, linkHref: '/articoli', linkNome: 'ARTICOLI'},
    ],
  };

  render() {
    const page = getPillarPageBySlug(this.props.slug);

    if (!page) {
      return null;
    }

    const articles = page.articleSlugs
      .map((slug) => creativeArticles.find((article) => article.slug === slug))
      .filter(Boolean);
    const relatedPages = page.related
      .map((slug) => getPillarPageBySlug(slug))
      .filter(Boolean);

    const pageJsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          '@id': `${siteUrl}${page.path}#webpage`,
          url: `${siteUrl}${page.path}`,
          name: page.seoTitle,
          description: page.description,
          isPartOf: {
            '@id': `${siteUrl}/#website`,
          },
          about: {
            '@id': `${siteUrl}/#book`,
          },
          hasPart: articles.map((article) => ({
            '@type': 'Article',
            name: article.title,
            url: `${siteUrl}${getArticlePath(article)}`,
          })),
          inLanguage: 'it-IT',
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}${page.path}#breadcrumb`,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Verso Hemelslinn',
              item: `${siteUrl}/`,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Articoli',
              item: `${siteUrl}/articoli`,
            },
            {
              '@type': 'ListItem',
              position: 3,
              name: page.title,
              item: `${siteUrl}${page.path}`,
            },
          ],
        },
      ],
    };

    return (
      <>
        <div className="page">
          <Seo
            title={page.seoTitle}
            description={page.description}
            path={page.path}
            image="/images/copertina-verso-hemelslinn.webp"
            jsonLd={pageJsonLd}
          />
          <Navbar
            linkSito="/"
            logo={logo}
            deskLogo="Logo di Verso Hemelslinn"
            brandName="Verso Hemelslinn"
            aNavbarLinks={this.state.aNavbarLinks}
          />
          <div id="pagina" className="pillar-page">
            <Intestazione
              pagina="ARTICOLI"
              paginaHref="/articoli"
              backgroundStyle={intestazioneBackgroundStyle}
              titolo={page.title.toUpperCase()}
              titoloAs="p"
              romanzo="il laboratorio narrativo di"
              autore="VERSO HEMELSLINN"
            />

            <section className="ftco-section seo-pillar-section content-pillar-section">
              <div className="container">
                <article className="seo-pillar-shell">
                  <p className="landing-kicker">Pagina pilastro</p>
                  <h1>{page.title}</h1>
                  <p className="seo-pillar-lead">{page.intro}</p>

                  <h2>Articoli pubblicati in questo percorso</h2>
                  <div className="creative-archive-grid pillar-article-grid">
                    {articles.map((article) => (
                      <article className="creative-archive-card" key={article.slug}>
                        <a href={getArticlePath(article)} className="creative-archive-image">
                          <img src={article.cover} alt={article.coverAlt} />
                        </a>
                        <div className="creative-archive-body">
                          <p className="creative-meta">
                            {article.date} · {article.readingTime}
                          </p>
                          <h3>
                            <a href={getArticlePath(article)}>{article.title}</a>
                          </h3>
                          <p>{article.subtitle}</p>
                          <a className="creative-text-link" href={getArticlePath(article)}>
                            Leggi l’articolo
                          </a>
                        </div>
                      </article>
                    ))}
                  </div>

                  {page.sections.map((section) => (
                    <section key={section.title}>
                      <h2>{section.title}</h2>
                      <p>{section.text}</p>
                      <div className="seo-pillar-card">
                        <h3>Roadmap editoriale</h3>
                        <ul>
                          {section.roadmap.map((item) => {
                            const roadmapItem = typeof item === 'string' ? {title: item} : item;

                            return (
                              <li
                                key={roadmapItem.title}
                                className={roadmapItem.completed ? 'roadmap-completed' : undefined}
                              >
                                <span>{roadmapItem.title}</span>
                                {roadmapItem.completed && roadmapItem.href ? (
                                  <a href={roadmapItem.href}>
                                    pubblicato: {roadmapItem.articleTitle}
                                  </a>
                                ) : null}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </section>
                  ))}

                  <h2>Percorsi collegati</h2>
                  <div className="seo-pillar-grid">
                    {relatedPages.map((relatedPage) => (
                      <div className="seo-pillar-card" key={relatedPage.slug}>
                        <h3>
                          <a href={relatedPage.path}>{relatedPage.title}</a>
                        </h3>
                        <p>{relatedPage.description}</p>
                      </div>
                    ))}
                  </div>
                  <section className="seo-pillar-faq" aria-labelledby="pillar-faq-title">
                    <h2 id="pillar-faq-title">Domande frequenti</h2>
                    <details open>
                      <summary>Che cos'e una pagina pilastro?</summary>
                      <p>Una pagina pilastro raccoglie articoli, roadmap e collegamenti interni intorno a un tema narrativo centrale.</p>
                    </details>
                    <details>
                      <summary>Gli articoli del percorso sono collegati tra loro?</summary>
                      <p>Si. Ogni articolo copre una parte del percorso e rimanda agli altri approfondimenti utili per continuare la lettura.</p>
                    </details>
                    <details>
                      <summary>Dove posso continuare?</summary>
                      <p>Puoi tornare all'<a href="/articoli">archivio degli articoli</a>, leggere il <a href="/summary">sommario</a> o seguire la <a href="https://hemelslinn.s.gy/vh-web-hem-land">campagna crowdfunding</a>.</p>
                    </details>
                  </section>
                </article>
              </div>
            </section>

            <Piedone
              piedoneCallToAction="Ogni tecnica diventa viva solo quando incontra una storia."
              piedoneLinkTermConditions=""
              piedoneLinkCookies="/cookies"
              piedoneLinkPrivacy="/privacy"
              piedoneIframe=""
              piedoneTwitter="https://x.com/Hemelslinn"
              piedoneInstagram="https://www.instagram.com/versohemelslinn/"
              piedoneFacebook="https://www.facebook.com/hemelslinn"
              piedoneTiktok="https://www.tiktok.com/@hemelslinn"
              piedoneDiscord=""
              piedonePinterest="https://it.pinterest.com/hemelslinn/"
              piedoneOpensea=""
              piedoneEliosfera="https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro"
              piedoneYoutube="https://www.youtube.com/@VersoHemelslinn"
              piedoneCopyright="Eliosfera Editrice &copy;"
              piedoneCopyrightDisclaimer="Tutti i diritti riservati"
              piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
            />
          </div>

          {AddLibrary('js/jquery.min.js')}
          {AddLibrary('js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary('js/jquery.waypoints.min.js')}
          {AddLibrary('js/jquery.stellar.min.js')}
          {AddLibrary('js/owl.carousel.min.js')}
          {AddLibrary('js/aos.js')}
          {AddLibrary('js/scrollax.min.js')}
          {AddLibrary('js/main.js')}
        </div>
      </>
    );
  }
}

function PillarRoute() {
  const {slug} = useParams();
  return <PillarPage slug={slug} />;
}

export {pillarPages};
export default PillarRoute;
